// One quote per day, indexed by day-of-month (1-based), keyed by calendar month (1-12).
// Sourced from Parker's "Weather Movie Quotes" set.

const monthlyQuotes = {
  "1": [
    "A new year isn't a reset button—it's the opening scene of your next adventure.",
    "Even the coldest morning can't freeze a determined spirit.",
    "Fresh snow writes tomorrow's story before your footprints ever do.",
    "The forecast changes. So can you.",
    "Every sunrise in January is another chance to surprise yourself.",
    "The first step is always colder than the second.",
    "Some storms arrive to remind us how strong we've become.",
    "New goals don't need perfect weather—just a willing heart.",
    "Winter teaches patience one frosty breath at a time.",
    "Every great journey begins with a single brave forecast.",
    "Don't wait for warmer days to start becoming who you want to be.",
    "A little sunshine can hide behind a sky full of clouds.",
    "The wind may push against you, but it also teaches balance.",
    "Snowflakes never race, yet they always arrive exactly on time.",
    "The strongest fires are often lit on the coldest nights.",
    "Today's forecast is only one page in your story.",
    "Some victories happen quietly, long before anyone notices.",
    "January rewards those who keep moving when everyone else stays inside.",
    "A frozen path still leads somewhere worth discovering.",
    "Dreams don't hibernate just because winter arrives.",
    "Even gray skies leave room for bright ideas.",
    "One warm smile can outshine an entire winter afternoon.",
    "Courage isn't waiting for sunshine—it's walking into the snow anyway.",
    "The calendar turned the page. Now it's your turn.",
    "Every season asks a different question. January asks, 'Will you begin?'",
    "Cold weather builds warm memories.",
    "A fresh start isn't found. It's created.",
    "The horizon always looks brighter after the longest night.",
    "Small victories have a way of becoming legendary.",
    "Every ending secretly rehearses a beginning.",
    "Roll the credits on yesterday. Today's feature has just begun."
  ],
  "2": [
    "Love isn't measured by the weather—only by who walks beside you.",
    "Even the shortest month leaves room for unforgettable moments.",
    "Every heartbeat is a reminder that hope has perfect timing.",
    "A little kindness can warm an entire winter day.",
    "The cold only makes genuine warmth easier to recognize.",
    "Some of life's best stories begin with a simple hello.",
    "A cloudy sky can still make room for bright possibilities.",
    "Not every hero wears a cape. Some just show up when they're needed.",
    "Winter may linger, but so does determination.",
    "The strongest bonds are built one small moment at a time.",
    "A single laugh can change the forecast of the entire day.",
    "Snow eventually melts, but great memories stick around.",
    "The bravest thing you can do today is keep moving forward.",
    "Every journey becomes easier when someone believes in you.",
    "A warm heart outlasts the coldest season.",
    "Today's forecast: equal chances of adventure and unexpected smiles.",
    "Some victories arrive quietly, disguised as ordinary days.",
    "Even bare trees know spring is on its way.",
    "The road ahead doesn't need to be clear—just worth taking.",
    "A little patience today becomes tomorrow's reward.",
    "Hope has a funny way of arriving right on schedule.",
    "Every sunrise writes another chance to begin again.",
    "The best companions make even stormy days feel lighter.",
    "Winter whispers that brighter seasons are getting closer.",
    "Great things often arrive before you're convinced they're possible.",
    "A heart full of courage is never out of season.",
    "Small moments of joy add up to extraordinary days.",
    "Leap toward the life you imagine—even if this isn't a leap year.",
    "The finish line belongs to those who keep showing up.",
    "Clouds never have the final word.",
    "Every ending in winter is secretly an invitation to spring."
  ],
  "3": [
    "Every breeze carries the promise of something new.",
    "Spring doesn't rush—it simply arrives when it's ready.",
    "A little rain is often the opening act for brighter days.",
    "The strongest roots grow beneath the quietest ground.",
    "Every storm leaves behind a cleaner sky.",
    "Luck is what happens when preparation meets opportunity.",
    "Fresh beginnings often wear muddy boots.",
    "The wind isn't trying to stop you—it's testing your balance.",
    "Every blossom was once just an idea beneath the soil.",
    "Today's clouds are tomorrow's colorful sunset.",
    "Sometimes the smallest seed grows into the greatest adventure.",
    "Rain has a funny way of making sunshine feel earned.",
    "Not every path is straight, but every path teaches something.",
    "The horizon always rewards those who keep walking.",
    "A splash in the puddles beats waiting for perfect weather.",
    "The forecast favors the bold.",
    "Even the wildest winds eventually find their calm.",
    "Change rarely knocks—it usually blows in.",
    "Green isn't just a color; it's a reminder that life always returns.",
    "Every sunrise deserves a second look.",
    "You don't have to chase spring—it already knows where to find you.",
    "Hope grows one day at a time.",
    "The best adventures usually begin with a change in the weather.",
    "Every rainbow starts with a little uncertainty.",
    "The world wakes up one blossom at a time.",
    "March reminds us that progress is rarely silent.",
    "Fresh air has a way of clearing old doubts.",
    "Some miracles arrive disguised as ordinary mornings.",
    "The season is changing. Maybe it's your turn too.",
    "When the wind changes direction, so can your story.",
    "Every ending of winter deserves an unforgettable beginning."
  ],
  "4": [
    "Every raindrop is another chance for something beautiful to grow.",
    "April reminds us that the brightest blooms often follow the darkest clouds.",
    "A rainy morning can still lead to a remarkable afternoon.",
    "New beginnings rarely ask for perfect weather.",
    "The sky may be gray, but the future rarely is.",
    "Every flower started as a quiet promise beneath the earth.",
    "Don't fear the rain—it teaches the sunshine how to shine.",
    "Fresh air has a way of refreshing old dreams.",
    "Every puddle reflects a different possibility.",
    "Spring doesn't ask permission. It simply arrives.",
    "Sometimes the best adventures begin with muddy shoes.",
    "Clouds are only temporary guests in the sky.",
    "The season of growth starts with believing it's possible.",
    "Every breeze carries whispers of tomorrow.",
    "A little rain today becomes tomorrow's garden.",
    "Even the smallest bloom changes the entire landscape.",
    "The forecast may change, but hope is always in season.",
    "Nature never hurries, yet somehow everything gets done.",
    "The sun always finds a way through the clouds.",
    "Every path looks different after the rain.",
    "April proves that change can be beautiful.",
    "The best stories are often written between the storms.",
    "Take the long way home—you might discover something unforgettable.",
    "Growth happens quietly before anyone notices.",
    "A single ray of sunshine can rewrite the whole day.",
    "Every storm leaves behind a lesson worth keeping.",
    "The world feels brand new when you choose to see it that way.",
    "Adventure doesn't wait for blue skies.",
    "Every season has a purpose. April's is renewal.",
    "Keep growing, even when no one is watching.",
    "The curtain rises on spring one rainy day at a time."
  ],
  "5": [
    "Every sunrise feels a little brighter when spring finds its stride.",
    "The world is in full bloom—don't be afraid to grow with it.",
    "Today's forecast: endless possibilities with a chance of adventure.",
    "The best journeys begin when you finally step outside.",
    "Every flower has its season. Yours might be today.",
    "Sunshine is contagious. Share it freely.",
    "A gentle breeze can carry the biggest dreams.",
    "The path ahead is greener than it looked yesterday.",
    "Every great story deserves a beautiful spring chapter.",
    "Bloom where today plants you.",
    "The horizon looks different when hope is in season.",
    "Some victories arrive quietly, like the first warm morning.",
    "Adventure often starts with opening the front door.",
    "The brightest days are built one sunrise at a time.",
    "Even the smallest garden can grow extraordinary things.",
    "Take the scenic route—you never know what you'll discover.",
    "Spring rewards those who stop long enough to notice it.",
    "Every warm afternoon feels like an invitation.",
    "The forecast can't measure determination.",
    "Fresh air has a way of inspiring fresh ideas.",
    "The strongest trees once bent in the wind.",
    "Every blossom reminds us that patience pays off.",
    "A clear sky is just another excuse to dream bigger.",
    "Great memories usually begin with, 'Why not?'",
    "Some roads are worth taking simply because they're beautiful.",
    "The season is changing—and so are the possibilities.",
    "Let today surprise you in the best way.",
    "The sun doesn't compete; it simply shines.",
    "A little courage can turn an ordinary day into an unforgettable one.",
    "Keep reaching toward the light, even when it's behind a cloud.",
    "The best adventures are still waiting just beyond the forecast."
  ],
  "6": [
    "Summer doesn't knock—it throws the door wide open.",
    "Every sunrise feels like an invitation to explore.",
    "The longest days are made for the biggest adventures.",
    "A warm breeze has a way of changing your plans for the better.",
    "The horizon always looks closer under a summer sky.",
    "Today's forecast: blue skies with a strong chance of unforgettable memories.",
    "Every road trip begins with a single turn of the key.",
    "The sun rises early because adventure can't wait.",
    "Sometimes the best destination isn't on the map.",
    "Life feels lighter when the days grow longer.",
    "Pack light, dream big, and let the journey surprise you.",
    "Every sunset is a standing ovation for the day you just lived.",
    "The world looks different through sunglasses and optimism.",
    "Great stories often start with, 'Let's see where this road goes.'",
    "Warm weather has a habit of waking up forgotten dreams.",
    "The best plans leave room for happy accidents.",
    "Even ordinary afternoons can become lifelong memories.",
    "Summer teaches us that slowing down isn't the same as standing still.",
    "Catch the sunshine while it's passing by.",
    "Every adventure deserves a soundtrack.",
    "The open road has a way of answering unasked questions.",
    "The brightest days are meant to be shared.",
    "There's magic in staying outside just a little longer.",
    "A gentle breeze can carry you toward something extraordinary.",
    "Today's best memory hasn't happened yet.",
    "Sometimes all you need is sunshine and a little curiosity.",
    "The sky is wide enough for every dream you dare to chase.",
    "Every summer evening feels like one more chance to begin again.",
    "The forecast favors explorers.",
    "The season is young—and so is the next adventure.",
    "Roll the windows down. Your next chapter is already waiting."
  ],
  "7": [
    "Freedom begins the moment you decide to chase the horizon.",
    "The hottest days often create the coolest memories.",
    "Today's forecast: sunshine with a high chance of adventure.",
    "Every firework starts as a spark that refuses to quit.",
    "Summer was made for stories worth retelling.",
    "The open sky reminds us there's always room to dream bigger.",
    "A warm breeze can carry you farther than you imagined.",
    "The best adventures usually happen after the plans change.",
    "Sunsets have a way of making every day feel complete.",
    "Celebrate the little victories—they light up life like fireworks.",
    "Every backyard can become the setting for an unforgettable story.",
    "The sun shines brightest on those who keep moving forward.",
    "Great memories don't wait for perfect timing.",
    "Some days are meant to be lived with your shoes off.",
    "The season is at its peak, and so are the possibilities.",
    "A clear sky is an invitation to explore.",
    "Every campfire starts with a single flame.",
    "The longest conversations happen after the sun goes down.",
    "Adventure doesn't need a passport—just a willing heart.",
    "Summer afternoons have a habit of becoming lifelong memories.",
    "Take the scenic route. Summer won't last forever.",
    "The brightest stars wait until the sun takes a bow.",
    "There's something magical about staying outside until the lights come on.",
    "Today's sunshine is tomorrow's favorite memory.",
    "The road ahead looks better with the windows down.",
    "Every laugh echoes a little louder in the summer air.",
    "The forecast calls for making the most of today.",
    "Freedom isn't just a holiday—it's a way of living.",
    "Even the hottest day cools into a beautiful evening.",
    "Make today sparkle like the Fourth of July.",
    "When summer reaches its peak, every moment feels like the grand finale."
  ],
  "8": [
    "Summer still has stories left to tell—don't close the book yet.",
    "Golden afternoons are reminders that every season has its masterpiece.",
    "Today's forecast: sunshine with a chance of one more adventure.",
    "The warmest days often become the fondest memories.",
    "Every sunset is summer's way of saying, 'See you tomorrow.'",
    "Hold on to the sunshine while it's still holding on to you.",
    "The road is still open, even if school is around the corner.",
    "Late summer teaches us to savor every moment.",
    "A gentle breeze can make an ordinary day unforgettable.",
    "Every adventure leaves a trail worth remembering.",
    "The season isn't ending—it's simply changing scenes.",
    "Some of the best memories happen just before the credits roll.",
    "The sky glows differently when summer begins to slow down.",
    "Today's sunshine is tomorrow's favorite photograph.",
    "Take one more walk. Watch one more sunset.",
    "The best days rarely announce themselves in advance.",
    "Every warm evening deserves an extra few minutes.",
    "The forecast says summer. Your heart says don't rush it.",
    "A little sunshine can carry you through an entire week.",
    "Every ending makes room for a brand-new beginning.",
    "Even the longest summer starts with a single sunny morning.",
    "Adventure doesn't follow a calendar.",
    "The horizon always rewards those who keep exploring.",
    "Some roads are worth driving twice.",
    "The golden hour has a way of making everything feel possible.",
    "The best souvenirs are the memories you never planned.",
    "A changing season doesn't mean the adventure is over.",
    "Make today's sunshine count.",
    "Every chapter deserves a memorable ending.",
    "The next adventure is already waiting just beyond the horizon.",
    "As summer takes its final bow, make sure you're still smiling."
  ],
  "9": [
    "Every new season begins with a single step forward.",
    "September arrives like a fresh page waiting to be written.",
    "Cooler air carries warmer memories from the summer behind us.",
    "Today's forecast: new beginnings with a chance of discovery.",
    "The leaves may change, but the adventure continues.",
    "A fresh breeze can bring a fresh perspective.",
    "Every sunrise is another opportunity to start something great.",
    "The best chapters often begin when the scenery changes.",
    "Change isn't the end of the story—it's the next scene.",
    "Autumn whispers that transformation can be beautiful.",
    "New routines create new possibilities.",
    "The road ahead looks clearer when you embrace the journey.",
    "Every falling leaf is proof that change can be graceful.",
    "The strongest trees know when to let go.",
    "A cooler morning can awaken the biggest dreams.",
    "The forecast favors those ready for a new adventure.",
    "Every season brings a different kind of magic.",
    "Small steps today become great journeys tomorrow.",
    "The world slows down just enough for us to notice it.",
    "Fresh starts don't require a perfect moment.",
    "The wind is changing, and so are the possibilities.",
    "A golden sunset is autumn's way of saying hello.",
    "Every challenge is just another chapter waiting to be conquered.",
    "The best discoveries often happen outside your comfort zone.",
    "September reminds us that endings can be beautiful beginnings.",
    "A new season means a new reason to explore.",
    "The morning air feels different when you're ready for change.",
    "Every leaf that falls makes room for something new.",
    "The journey continues, just with a different soundtrack.",
    "Cooler days, brighter ideas, endless possibilities.",
    "Welcome the change. The best is still ahead."
  ],
  "10": [
    "The fog rolls in, and every path becomes a mystery waiting to be solved.",
    "October proves that a little darkness makes the lights shine brighter.",
    "Today's forecast: crisp air with a chance of unexpected adventures.",
    "Every falling leaf carries a story from seasons gone by.",
    "The wind whispers secrets only autumn can understand.",
    "Some of the best journeys begin after sunset.",
    "A chilly evening is just an invitation to gather closer.",
    "The moon shines brighter when the world gets quieter.",
    "Every shadow has a story, and every story has a beginning.",
    "Autumn paints the world in colors no camera can truly capture.",
    "The coolest nights create the warmest memories.",
    "A little mystery makes every day more interesting.",
    "The leaves are falling, but your dreams should keep rising.",
    "Every storm cloud carries a little bit of magic.",
    "The season of imagination has arrived.",
    "A lantern in the darkness can guide an entire journey.",
    "October reminds us that change can be beautiful and mysterious.",
    "The crisp air is nature's way of turning the page.",
    "Every old trail has a new adventure hiding somewhere along it.",
    "The stars seem brighter when the nights grow longer.",
    "A quiet forest can tell louder stories than a crowded room.",
    "The best costumes are the ones worn by fearless imaginations.",
    "Every pumpkin begins as a tiny seed with a big future.",
    "The night sky is the original movie screen.",
    "Some surprises are waiting just beyond the next corner.",
    "A little courage can turn a spooky night into a great story.",
    "Welcome to Prime-Time, Bitch!.",
    "Every candle has a purpose: to push back the darkness.",
    "The final chapter of autumn is often the most unforgettable.",
    "Embrace the chill. The magic is in the air.",
    "When October arrives, ordinary days become extraordinary tales."
  ],
  "11": [
    "Gratitude is the warmth that carries us through colder days.",
    "November reminds us that the quiet moments can become the greatest memories.",
    "Today's forecast: cozy skies with a strong chance of appreciation.",
    "The leaves may fall, but the reasons to be thankful keep growing.",
    "A warm heart can brighten even the grayest afternoon.",
    "Every gathering creates a story worth remembering.",
    "The changing seasons remind us to treasure what stays.",
    "A simple moment of kindness can become someone's favorite memory.",
    "Cold winds outside make warm conversations feel even better.",
    "The best adventures aren't always far away—they're often around the table.",
    "Every sunrise is a reminder that there's still more to discover.",
    "A grateful spirit can turn an ordinary day into something extraordinary.",
    "The quiet beauty of November is found in the moments we slow down to notice.",
    "Every cup of warmth carries a little comfort with it.",
    "The strongest bonds are built through shared stories and simple moments.",
    "A cloudy sky can't hide a thankful heart.",
    "Some of life's greatest treasures can't be wrapped or bought.",
    "The season of giving begins with a single generous thought.",
    "Every family has a story, and every story deserves to be shared.",
    "The frost may arrive, but kindness never goes out of season.",
    "Small blessings often create the biggest smiles.",
    "The best memories are made when people make time for each other.",
    "A little patience and a little gratitude can weather any storm.",
    "November teaches us that endings can still be beautiful.",
    "Every meal tastes better when shared with good company.",
    "The colder the evening, the brighter the moments we create.",
    "A thankful heart always finds sunshine somewhere.",
    "The harvest reminds us that every effort has a season of reward.",
    "The world grows quieter, giving us more chances to listen.",
    "Before winter arrives, take a moment to appreciate today.",
    "The greatest gifts are often the memories we create together."
  ],
  "12": [
    "December arrives like the final scene of a year worth remembering.",
    "The first snowfall reminds us that every ending can be beautiful.",
    "Today's forecast: sparkling skies with a chance of unforgettable moments.",
    "The year may be closing, but the story is still being written.",
    "Cold nights create the perfect setting for warm memories.",
    "Every light in the darkness is a reminder that hope always returns.",
    "The greatest gifts are the moments we share with others.",
    "A quiet snowfall can say what words sometimes cannot.",
    "The final chapter often reveals the greatest surprises.",
    "December teaches us to slow down and enjoy the magic around us.",
    "Every snowflake proves that small things can become extraordinary.",
    "The best celebrations are built from laughter, kindness, and connection.",
    "A new beginning is hiding inside every goodbye.",
    "The stars shine brighter when the year grows quiet.",
    "Every winter morning holds a little bit of wonder.",
    "The forecast calls for joy, with scattered chances of nostalgia.",
    "The memories we make today become tomorrow's treasures.",
    "A warm fire and a grateful heart can defeat the coldest night.",
    "The season of giving reminds us how powerful kindness can be.",
    "Every ending deserves a moment of celebration.",
    "Snow may cover the ground, but it reveals the beauty of the world.",
    "The year's final sunset deserves your full attention.",
    "Some of the best stories begin around a holiday table.",
    "The countdown isn't just to a new year—it's to new possibilities.",
    "A little sparkle can turn an ordinary day into a celebration.",
    "The magic of December is found in the moments we choose to share.",
    "Every winter star carries a wish waiting to be discovered.",
    "The cold outside makes the warmth within shine brighter.",
    "The final pages of the year are meant to be savored.",
    "Tomorrow's adventure begins with today's gratitude.",
    "The calendar turns, but the memories stay forever."
  ]
};

export default monthlyQuotes;
